import { T4 } from 'ia-react-core';
import styled from 'styled-components';

export const StyledSectionTitle = styled(T4)`
  margin: 0 16px 16px 16px;
`;

export const StyledSection = styled.div`
  &:not(:first-of-type) {
    margin-top: 24px;
  }
`;
